import * as request from './genericRequest';

const AdminRoute = 'admin';
const MessagesRoute = 'messages/admin';

export const getAdminData = async () => request.getApi(AdminRoute);
export const getMessagesByTopic = async ({ topicName }) => request.getApi(MessagesRoute, { topicName });
